import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Compliance {
  private apiUrl: string = environment.apiUrl;

  constructor(private _http: HttpClient) {}

  public postScanning(scanningSide: string): Observable<any> {
    return this._http
      .post<any>(`${this.apiUrl}scan-images`, {
        command: scanningSide,
      })
      .pipe(
        catchError((error) => {
          console.error('Error in postScanning:', error);
          return of(null);
        }),
      );
  }

  public getScanning(scanningSide: string, requestId: any): Observable<any> {
    return this._http.get<any>(`${this.apiUrl}scan-result?request_id=${requestId}`).pipe(
      catchError((error) => {
        console.error('Error in postScanning:', error);
        return of(null);
      }),
    );
  }

  public uploadImgs(req_id_front: string, req_id_back: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { req_id_front, req_id_back };
    return this._http.post<any>(`${this.apiUrl}cash_cage_idv_submit`, body, { headers }).pipe(
      catchError((error) => {
        console.error('Error in postScanning:', error);
        return of(null);
      }),
    );
  }

  public getProofResults(operation_id: string) {
    return this._http.get<any>(`${this.apiUrl}get_proof_results/${operation_id}`).pipe(
      catchError((error) => {
        console.error('Error in postScanning:', error);
        return of(null);
      }),
    );
  }

  public cashCage(cashCageData:any){
    const path = cashCageData.isPatron ? 'security/packages/order' : 'cash_cage/packages/order';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.post<any>(`${this.apiUrl}${path}`, cashCageData,{ headers }).pipe(
      catchError((error) => {
        console.error('Error in postScanning:', error);
        return of(null);
      }),
    );
  }
  
  public verifySSN(ssn:any){
    return this._http.get<any>(`${this.apiUrl}v1/verify/ssn/${ssn}`).pipe(
      catchError((error) => {
        console.error('Error in postScanning:', error);
        return of(null);
      }),
    );
  }

  public findSSN(data: {
    first_name: string;
    last_name: string;
    dob: string;
    middle_name?: string;
    address_street?: string;
  }): Observable<{ ssn: string; found: boolean }> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.post<{ ssn: string; found: boolean }>(
      `${this.apiUrl}/packages/execute-rule/find-ssn`,
      {
        first_name: data.first_name,
        last_name: data.last_name,
        dob: data.dob,
        middle_name: data.middle_name,
        address: data.address_street
      },
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('Error in findSSN:', error);
        return of({ ssn: '', found: false });
      })
    );
  }
}